import { render, staticRenderFns } from "./FormInputFormatter.vue?vue&type=template&id=f7cf71c4&"
import script from "./FormInputFormatter.vue?vue&type=script&lang=js&"
export * from "./FormInputFormatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports